import { render, staticRenderFns } from "./Set.vue?vue&type=template&id=9bff0da8&scoped=true&"
import script from "./Set.vue?vue&type=script&lang=js&"
export * from "./Set.vue?vue&type=script&lang=js&"
import style0 from "./Set.vue?vue&type=style&index=0&id=9bff0da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bff0da8",
  null
  
)

export default component.exports